<script lang="ts">
    import {
        List,
        ListItemGroup,
        NavigationDrawer,
        ListItem,
    } from "svelte-materialify/src";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    function linkClick(link: string): void {
        dispatch("linkClick", link);
    }

    export let links: string[];
    export let activeLink: string;
</script>

<NavigationDrawer fixed borderless style="background: transparent">
    <div class="drawer-header primary-text remove-break">
        <h6 class="text-h6 normal-line">Alexander Carpenter</h6>
        <h6 class="text-h6 drawer-subtitle normal-line">Software Engineer</h6>
    </div>
    <List nav>
        <ListItemGroup
            class="d-flex justify-space-around flex-column align-center list"
        >
            {#each links as link}
                <ListItem
                    on:click={() => linkClick(link)}
                    class={`list-item primary-text${
                        activeLink === link ? " active-link" : ""
                    }`}
                    activeClass=""
                >
                    {link}
                </ListItem>
            {/each}
        </ListItemGroup>
    </List>
</NavigationDrawer>
